import React from 'react'
import PropTypes from 'prop-types'
import cloneDeep from 'lodash.clonedeep';
import ReactEcharts from './ReactEcharts';

class StackedBarChart2 extends React.Component {
  constructor(props) {
    super(props)
    this.itemStyle = {
      normal: {
      },
      emphasis: {
        barBorderWidth: 1,
        shadowBlur: 10,
        shadowOffsetX: 0,
        shadowOffsetY: 0,
        shadowColor: 'rgba(0,0,0,0.5)'
      }
    };

    this.state = this.getInitialState();
    this.updateChart(props)
  }
  getInitialState = () => ({option: this.getOption()});

  componentWillReceiveProps(nextProps) {
    if (nextProps.data === this.props.data && nextProps.listRange === this.props.listRange)
      return;
    this.updateChart(nextProps)
  }

  shouldComponentUpdate(nextProps, nextState) {
    if(nextState !== this.state)
      return true;
    if(nextProps.data !== this.props.data ||
      nextProps.listRange !== this.props.listRange)
      return true;
    return false
  }

  getOption = () => ({
    color: ['#fb8072', '#80b1d3', '#fdb462', '#b3de69', '#fccde5', '#d9d9d9',
      '#bc80bd', '#ccebc5', '#8dd3c7', '#ffffbc', '#bebada', '#ffed6f'],
    tooltip : {
      trigger: 'axis',
      axisPointer : {
        type : 'shadow'
      }
    },
    xAxis: {
      data: [],
      silent: false,
      axisLine: {onZero: true},
      splitLine: {show: false},
      splitArea: {show: false}
    },
    yAxis: {
      splitArea: {show: false}
    },
    grid: {
      top: 10,
      bottom: 24,
      left: 40,
      right: 10
    },
    series: []
  });

  updateChart = (props) => {
    let {sizeFactor} = props;
    if(!sizeFactor) sizeFactor = 1;
    let {schema, data, listRange, tooltipSide, thumbMode, noanim} = props;
    if(!schema || !data || !data.length)
      return;

    const option = cloneDeep(this.state.option); // immutable
    let data_slice = listRange ? data.slice(listRange[0], listRange[1]) : data.slice(0, 20);

    option.grid = {
      top: 10 * sizeFactor,
      bottom: 24 * sizeFactor,
      left: 40 * sizeFactor,
      right: 10 * sizeFactor
    };

    option.xAxis.data = data_slice.map(d => d.name);
    option.xAxis.axisLabel = {fontSize: 12 * sizeFactor};
    option.yAxis.axisLabel = {fontSize: 12 * sizeFactor};
    option.series = schema.map((s, index) => ({
      name: s.name,
      type: 'bar',
      stack: 'main',
      itemStyle: this.itemStyle,
      data: data_slice.map(d => d.values[index])
    }));
    if(thumbMode) {
      option.xAxis.show = false;
      option.yAxis.show = false;
      option.grid = {top:0, bottom:0, left:0, right:0, show:true};
    }
    if(noanim) {
      option.animation = false;
    }
    if(tooltipSide)
      option.tooltip.position = (point, params, dom, rect, size) => [point[0] + 10, point[1] - size.contentSize[1] - 20]

    this.setState({
      option,
    });
  };

  onChartClick(params) {
    if(params.componentType !== 'series') {
      console.log(params);
      return;
    }
    if(this.props.onSelected)
      this.props.onSelected(params.dataIndex + (this.props.listRange ? this.props.listRange[0]: 0))
  }

  render() {
    let onEvents = {
      'click': this.onChartClick.bind(this),
    }
    return (
      <ReactEcharts ref='echarts_react'
        option={this.state.option}
        style={{width: this.props.width, height: this.props.height}}
        onEvents={onEvents}
      />
    )
  }
}
 
StackedBarChart2.propTypes = {
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
  schema: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      id: PropTypes.number.isRequired,
    })
  ),
  data: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      id: PropTypes.number.isRequired,
      values: PropTypes.arrayOf(PropTypes.number.isRequired)
    }).isRequired
  ).isRequired,
  onSelected: PropTypes.func,
}

export default StackedBarChart2
